module.exports = "/images/ico-visa-mc.svg?ff5c8be2fb23ff9ce72cf1de8a13607c";